export default __webpack_public_path__ + "static/media/five-states-of-ready-thumbnail.70e07452.png";